import classnames from 'classnames';
import I18n from 'i18n-js';
import React, { useContext } from 'react';
import { withRouter, WithRouterProps } from 'react-router';

import { RCButton } from '@reverbdotcom/commons/src/rc';
import { RCTextWithIcon } from '@reverbdotcom/commons/src/rc/RCTextWithIcon';
import ArrowLeftSvg from '@reverbdotcom/commons/design-system/icons/core/arrow-left.svg?component';

import { SellFormContext } from '../SellFormContext';
import { getUrlForSection, Section } from '../sellFormViewSections';
import { SellFormPublish } from './SellFormPublish';
import Location from '../../../../lib/wrapped_location';

export enum ButtonType {
  CONTINUE = 'continue',
  PREVIOUS_SECTION = 'previousSection',
  PUBLISH = 'publish',
  DISCARD = 'discard',
  GO_TO_REVIEW = 'goToReview',
}

interface IExternalProps {
  buttons: ButtonType[];
  disableSubmit: boolean;
}

function SellFormSectionButtons({
  buttons,
  location,
  disableSubmit = false,
}: IExternalProps & WithRouterProps) {
  const {
    onNavigationClick,
    previousSection,
    loading,
    isDraft,
  } = useContext(SellFormContext);

  if (buttons.length < 1) { return null; }

  return (
    <div className={classnames('sell-form-section-buttons', { 'sell-form-section-buttons--submit-disabled': loading || disableSubmit })}>
      {buttons.includes(ButtonType.GO_TO_REVIEW) && (
        <RCButton
          aria-disabled={loading}
          variant="secondary"
          onClick={(e) => {
            e.preventDefault();
            Location.assign(getUrlForSection(location, Section.REVIEW));
          }}
        >
          <RCTextWithIcon svgComponent={ArrowLeftSvg} placement="left">
            {I18n.t('discovery.sellForm.section.back')}
          </RCTextWithIcon>
        </RCButton>
      )}

      {buttons.includes(ButtonType.PREVIOUS_SECTION) && previousSection && (
        <RCButton
          variant="secondary"
          disabled={loading}
          onClick={(e) => {
            e.preventDefault();
            onNavigationClick(previousSection);
          }}
        >
          {I18n.t('discovery.sellForm.section.back')}
        </RCButton>
      )}

      {buttons.includes(ButtonType.DISCARD) && (
        <RCButton
          aria-disabled={loading}
          variant="secondary"
          onClick={(e) => {
            e.preventDefault();
            Location.reload();
          }}
        >
          {I18n.t('discovery.sellForm.section.discard')}
        </RCButton>
      )}

      {buttons.includes(ButtonType.PUBLISH) && <SellFormPublish disabled={loading || disableSubmit}/>}

      {buttons.includes(ButtonType.CONTINUE) && (
        <RCButton
          aria-disabled={loading || disableSubmit}
          variant="primary"
          isSubmit
        >
          {I18n.t(`discovery.sellForm.section.continue.${isDraft ? 'draft' : 'nonDraft'}`)}
        </RCButton>
      )}
    </div>
  );
}

export default withRouter(SellFormSectionButtons);
